// Liability Service - API calls to LiabilityController
import api from '@/plugins/axios';

const SERVICE_PATH = '/symbol-service/api/v1/liabilities';

export default {
  // ==================== Liabilities CRUD ====================

  /**
   * Get all liabilities for the current user
   * GET /symbol-service/api/v1/liabilities
   */
  getAllLiabilities(userEmail) {
    return api.get(SERVICE_PATH, {
      params: {
        userId: userEmail
      }
    });
  },

  /**
   * Get a specific liability by ID
   * GET /symbol-service/api/v1/liabilities/{id}
   */
  getLiability(id) {
    return api.get(`${SERVICE_PATH}/${id}`);
  },

  /**
   * Get liability count for the current user
   * GET /symbol-service/api/v1/liabilities/count
   */
  getLiabilityCount(userEmail) {
    return api.get(`${SERVICE_PATH}/count`, {
      params: {
        userId: userEmail
      }
    });
  },

  /**
   * Create a new liability
   * POST /symbol-service/api/v1/liabilities
   */
  createLiability(liability) {
    return api.post(SERVICE_PATH, liability);
  },

  /**
   * Update an existing liability
   * PUT /symbol-service/api/v1/liabilities/{id}
   */
  updateLiability(id, liability) {
    return api.put(`${SERVICE_PATH}/${id}`, liability);
  },

  /**
   * Delete a liability
   * DELETE /symbol-service/api/v1/liabilities/{id}
   */
  deleteLiability(id) {
    return api.delete(`${SERVICE_PATH}/${id}`);
  },

  /**
   * Manually recalculate amortization for a liability
   * POST /symbol-service/api/v1/liabilities/{id}/recalculate
   */
  recalculateLiability(id) {
    return api.post(`${SERVICE_PATH}/${id}/recalculate`);
  },

  // ==================== Payments CRUD ====================

  /**
   * Get all payments for the current user
   * GET /symbol-service/api/v1/liabilities/payments
   */
  getAllPayments() {
    return api.get(`${SERVICE_PATH}/payments`);
  },

  /**
   * Get all payments for a specific liability
   * GET /symbol-service/api/v1/liabilities/{liabilityId}/payments
   */
  getPaymentsForLiability(liabilityId) {
    return api.get(`${SERVICE_PATH}/${liabilityId}/payments`);
  },

  /**
   * Get a specific payment by ID
   * GET /symbol-service/api/v1/liabilities/payments/{paymentId}
   */
  getPayment(paymentId) {
    return api.get(`${SERVICE_PATH}/payments/${paymentId}`);
  },

  /**
   * Create a new payment
   * POST /symbol-service/api/v1/liabilities/payments
   */
  createPayment(payment) {
    return api.post(`${SERVICE_PATH}/payments`, payment);
  },

  /**
   * Update an existing payment
   * PUT /symbol-service/api/v1/liabilities/payments/{paymentId}
   */
  updatePayment(paymentId, payment) {
    return api.put(`${SERVICE_PATH}/payments/${paymentId}`, payment);
  },

  /**
   * Delete a payment
   * DELETE /symbol-service/api/v1/liabilities/payments/{paymentId}
   */
  deletePayment(paymentId) {
    return api.delete(`${SERVICE_PATH}/payments/${paymentId}`);
  },

  /**
   * Get payment summary for a liability
   * GET /symbol-service/api/v1/liabilities/{liabilityId}/payments/summary
   */
  getPaymentSummary(liabilityId) {
    return api.get(`${SERVICE_PATH}/${liabilityId}/payments/summary`);
  },

  /**
   * Get liabilities summary (totals, counts, nearest payoff)
   * GET /symbol-service/api/v1/liabilities/summary
   */
  getLiabilitiesSummary() {
    return api.get(`${SERVICE_PATH}/summary`);
  }
};

